<template>
  <div class="itLoading" v-show="showLoading">
    <img v-show="false" ref="part1" src="@/assets/image/sources/part1.png">
    <img v-show="false" ref="part2" src="@/assets/image/sources/part2.png">
    <img v-show="false" ref="part3" src="@/assets/image/sources/part3.png">
    <canvas ref="animationCanvas" class="animationCanvas"></canvas>
  </div>
</template>

<script>
import {imageAnimationLoad} from "@/utils/utils";

export default {
  name: "itLoading",
  data() {
    return {
      showLoading: false,
      animationId: 0,
      forId: 1,
      part1End: true
    }
  },
  methods: {
    /**
     * 停止动画
     */
    stopAnimation() {
      if (this.part1) {
        this.part1.stop();
      }
      if (this.part2) {
        this.part2.stop();
      }
      if (this.part3) {
        this.part3.stop();
      }
      this.showLoading = false
      clearTimeout(this.animationId)
      clearInterval(this.forId)
      console.log('执行 stopAnimation')
    },
    /**
     * 播放动画
     * @returns {Promise<void>}
     */
    async playAnimation() {
      this.stopAnimation()
      console.log('执行 playAnimation')
      this.$nextTick(async () => {
        this.showLoading = true
        this.part1End = false
        this.clearRect()
        this.part1 = await imageAnimationLoad(this.$refs.part1, this.$refs.animationCanvas, {numPlays: 1});
        this.part1.addListener('end', async () => {
          this.part1End = true
          this.part2 = await imageAnimationLoad(this.$refs.part2, this.$refs.animationCanvas)
          this.part2.play();
        })
        this.part1.play();
      })
    },
    /**
     * 下一个动画
     * @returns {Promise<unknown>}
     */
    async nextAnimation() {
      console.log('执行 nextAnimation')
      clearTimeout(this.animationId)
      clearInterval(this.forId)
      this.forId = setInterval(async () => {
        if (this.part1End) {
          this.part1End = false
          if (this.part2) {
            this.animationId = setTimeout(() => {
              this.part2.stop();
              this.play3()
              clearTimeout(this.animationId)
            }, 1500)
            clearInterval(this.forId)
          } else {
            await this.play3()
          }
        }
      }, 1000)
    },
    async play3() {
      this.part3 = await imageAnimationLoad(this.$refs.part3, this.$refs.animationCanvas, {numPlays: 1})
      this.part3.addListener('end', () => {
        this.clearRect()
        this.showLoading = false
        clearInterval(this.forId)
      })
      this.part3.play();
    },
    clearRect() {
      const d2 = this.$refs.animationCanvas.getContext('2d')
      d2.clearRect(0, 0, this.$refs.animationCanvas.width, this.$refs.animationCanvas.height)
    }
  }
}
</script>

<style scoped lang="scss">
.itLoading {
  position: absolute;
  z-index: 999;
  height: 100%;
  width: 100%;
  background: white;
}

.animationCanvas {
  width: 100%;
  height: 100%;
  background: transparent;
}

</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/teachingDetail/list/classroom/itLoading.vue